<script lang="ts">
  import { Tween } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';
  import NavButton from '~/components/NavButton.svelte';
  import { gameOverModal } from '~/routes/classic/GameOver.svelte';
  import { getGame } from '~/store/GameContext.svelte';

  type Props = {
    score: number;
  };
  const props: Props = $props();
  const game = $derived(getGame().current);
  // svelte-ignore state_referenced_locally
    let newScore = new Tween(props.score, {
    duration: 750,
    easing: cubicOut,
  });

  $effect(() => {
    newScore.target = props.score;
  });

  const handleOpenGameOver = () => {
    gameOverModal.push();
  };
</script>

{#if game.lost}
  <div class="container">
    <NavButton onClick={handleOpenGameOver}>
      <span class="final-score-label"> final score </span>
      <span class="final-score">
        {props.score} pts
      </span>
    </NavButton>
  </div>
{:else}
  <span class="score" class:animate={props.score !== newScore.current}>
    {Math.round(newScore.current)} pts
  </span>
{/if}

<style lang="scss">
  @use '~/theme/include-media' as *;

  @keyframes grow-shrink {
    0% {
      transform: scale(1);
      animation-timing-function: ease-in;
    }
    50% {
      transform: scale(1.5);
      animation-timing-function: ease-out;
    }
    100% {
      transform: scale(1);
    }
  }

  .score {
    position: absolute;
    top: 0;
    right: 0;
    font-weight: bold;
    font-size: 1.75rem;
    @include media('height<=tablet') {
      font-size: 1.25rem;
    }

    &.animate {
      animation-name: grow-shrink;
      animation-duration: 0.75s;
    }
  }
  .container {
    :global(.nav-button) {
      text-decoration: none;
    }
    .final-score-label {
      text-decoration: underline;
    }
    .final-score {
      font-weight: bold;
      text-decoration: none;
    }
  }
</style>
